import { useEffect } from "react";
import { useLocation } from "react-router-dom";
// const { NODE_ENV } = process.env;

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export const ImageUrl = (image) => {
  let { PUBLIC_URL } = process.env;
  return `${PUBLIC_URL}/assets/images/${image}`;
};
export const extractDate = (date) => {
  const dateObj = new Date(date);
  const options = {
    timeZone: "UTC",
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  const formattedDate = dateObj.toLocaleDateString("en-US", options);
  return formattedDate;
};

// export const extractTime = (date) => {
//   const dateObj = new Date(date);
//   const timeString = dateObj.toLocaleTimeString([], {
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: true,
//     timeZone: "UTC",
//   });
//   return timeString;
// };
export const extractTime = (date) => {
  const dateObj = new Date(date);
  // Convert to Eastern Time Zone (America/New_York)
  const timeString = dateObj.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "America/New_York",
  });
  return timeString;
};
export const calculateReviewsAverage = (reviews) => {
  if (!reviews || reviews?.length === 0) {
    return 0;
  }
  const totalRatings = reviews.reduce((sum, review) => sum + review.rating, 0);
  const averageRating = totalRatings / reviews?.length;
  return averageRating;
};

export const checkInCity = (pickupLocation, dropoffLocation) => {
  if (!pickupLocation || !dropoffLocation) {
    return false;
  }

  const isInManhattan = (coordinates) => {
    if (!coordinates || coordinates.length < 2) return false;

    const [lng, lat] = coordinates;

    // Coordinates for Manhattan, New York City
    return (
      lat >= 40.7000 &&
      lat <= 40.8150 &&
      lng >= -74.02 &&
      lng <= -73.93
    );
    
    // khi coordinates to test
  //   return (
  //   lat >= 24.7900 &&
  //   lat <= 25.0500 &&
  //   lng >= 66.8200 &&
  //   lng <= 67.3000
  // );
  };

  const pickupInCity = isInManhattan(pickupLocation.coordinates);
  const dropoffInCity = isInManhattan(dropoffLocation.coordinates);

  return pickupInCity && dropoffInCity;
};
